export default __webpack_public_path__ + "static/media/icon-kb-light.0f161945.svg";